import React from 'react'
import { Nav, NavLink, NavbarContainer, Span, NavLogo, NavItems, GitHubButton, ButtonContainer, MobileIcon, MobileMenu, MobileLink } from './NavbarStyledComponent'
import { FaBars } from 'react-icons/fa';
import { Bio } from '../../data/constants';
import { useTheme } from 'styled-components';

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [activeSection, setActiveSection] = React.useState('about');
  const theme = useTheme();

  React.useEffect(() => {
    const handleScroll = () => {
      const sections = ['about', 'workflow', 'skills', 'experience', 'analytics', 'docs', 'projects', 'education'];
      let current = 'about';
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          // If the section top is above the navbar boundary (y=150px)
          if (rect.top <= 150) {
            current = section;
          }
        }
      }
      
      if (activeSection !== current) {
        setActiveSection(current);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger initial check
    return () => window.removeEventListener('scroll', handleScroll);
  }, [activeSection]);

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
        <a href="/" style={{ display: "flex", alignItems: "center", color: "white", marginBottom: '20px', cursor: 'pointer' }}>
    <img 
      src="https://raw.githubusercontent.com/Rakeshere/web-docx/main/image.png" 
      alt="Logo" 
      style={{ width: '80px', height: '80px', marginRight: '10px', marginTop:'22px' }} 
    />
    <Span></Span>
  </a>
        </NavLogo>
        <MobileIcon>
          <FaBars onClick={() => {
            setIsOpen(!isOpen)
          }} />
        </MobileIcon>
        <NavItems>
          <NavLink href="#about" className={activeSection === 'about' ? 'active' : ''}>About</NavLink>
          <NavLink href='#workflow' className={activeSection === 'workflow' ? 'active' : ''}>Workflow</NavLink>
          <NavLink href='#skills' className={activeSection === 'skills' ? 'active' : ''}>Skills</NavLink>
          <NavLink href='#experience' className={activeSection === 'experience' ? 'active' : ''}>Experience</NavLink>
          <NavLink href='#analytics' className={activeSection === 'analytics' ? 'active' : ''}>Analytics</NavLink>
          <NavLink href='#docs' className={activeSection === 'docs' ? 'active' : ''}>Library</NavLink>
          <NavLink href='#projects' className={activeSection === 'projects' ? 'active' : ''}>Projects</NavLink>
          <NavLink href='#education' className={activeSection === 'education' ? 'active' : ''}>Education</NavLink>
        </NavItems>
        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank">Github Profile</GitHubButton>
        </ButtonContainer>
        {
          isOpen &&
          <MobileMenu isOpen={isOpen}>
            <MobileLink href="#about" onClick={() => {
              setIsOpen(!isOpen)
            }}>About</MobileLink>
            <MobileLink href='#workflow' onClick={() => {
              setIsOpen(!isOpen)
            }}>Workflow</MobileLink>
            <MobileLink href='#skills' onClick={() => {
              setIsOpen(!isOpen)
            }}>Skills</MobileLink>
            <MobileLink href='#experience' onClick={() => {
              setIsOpen(!isOpen)
            }}>Experience</MobileLink>
            <MobileLink href='#analytics' onClick={() => {
              setIsOpen(!isOpen)
            }}>Analytics</MobileLink>
            <MobileLink href='#docs' onClick={() => {
              setIsOpen(!isOpen)
            }}>Library</MobileLink>
            <MobileLink href='#projects' onClick={() => {
              setIsOpen(!isOpen)
            }}>Projects</MobileLink>
            <MobileLink href='#education' onClick={() => {
              setIsOpen(!isOpen)
            }}>Education</MobileLink>
            <GitHubButton style={{padding: '10px 16px',background: `${theme.primary}`, color: 'white',width: 'max-content'}} href={Bio.github} target="_blank">Github Profile</GitHubButton>
          </MobileMenu>
        }
      </NavbarContainer>
    </Nav>
  )
}

export default Navbar